<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.dateRange }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.tranDateFrom"
                            :label="labels.tranDateFrom"
                            :data-vv-as="labels.tranDateFrom"
                            data-vv-name="forms.tranDateFrom"
                            :error-messages="errors.collect('forms.tranDateFrom')"
                            v-validate="tranDateFromValidation"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.tranDateTo"
                            :label="labels.tranDateTo"
                            :data-vv-as="labels.tranDateTo"
                            data-vv-name="forms.tranDateTo"
                            :error-messages="errors.collect('forms.tranDateTo')"
                            v-validate="tranDateToValidation"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.filters }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="dRiList"
                            v-model="forms.dRi"
                            :label="labels.dRi"
                            item-text="label"
                            item-value="value"
                            data-vv-name="forms.dRi"
                            :data-vv-as="labels.dRi"
                            :error-messages="errors.collect('forms.dRi')"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg6 xs6></v-flex>

                        <v-flex xs12 sm6 md6 lg6>
                          <v-text-field
                            readonly
                            v-model="forms.busCls"
                            :label="labels.busCls"
                            :error-messages="errors.collect('forms.busCls')"
                            data-vv-name="forms.busCls"
                            :data-vv-as="labels.busCls"
                            append-icon="mdi-magnify"
                            @click:append="getBusClsHelpList()"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
                        <v-flex xs12 sm12 md12 lg12 class="pt-3">
                          <v-btn color="primary" type="submit" :loading="loading" @click.prevent="doSubmit">
                            <v-icon left dark>mdi-file-export</v-icon>
                            {{ labels.export }}
                          </v-btn>
                          <v-btn-toggle dense mandatory v-model="forms.format">
                            <v-btn class="ml-2" text v-for="format in supportedList" :key="format.value" :value="format.value">
                              <span :style="{ textTransform: 'none' }">{{ format.label }}</span>
                              <v-icon>mdi-file-document</v-icon>
                            </v-btn>
                          </v-btn-toggle>
                        </v-flex>
        <v-dialog v-model="busClsList" width="900px" persistent>
          <multi-bus-cls-help-list :busCls="forms.busCls" :busClsAppId="'MO'" @close="doClose" @doAssign="doAssign($event)"></multi-bus-cls-help-list>
        </v-dialog>
      </v-layout>
    </v-container>

    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList.vue'
import { expandURI } from '@/utils/ajax'
// import { downloadPrompt } from '@/utils/file'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Range',
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        filters: 'Filters',
        dRi: 'Direct / RI Inwards',
        busCls: 'Business Class',
        export: 'Export To',
        format: 'Json File'
      },
      forms: {
        tranDateFrom: null,
        tranDateTo: null,
        dRi: true,
        busCls: 'All',
        format: undefined
      },
      dRiList: [
        {
          label: 'Direct',
          value: true
        },
        {
          label: 'RI Inwards',
          value: false
        }
      ],
      busClsList: false,
      loading: false,
      supportedList: [
        {
          label: 'ASCII TEXT',
          value: 'txt'
        },
        {
          label: 'Json File',
          value: 'json'
        }
      ],
      showErrorDialog: false,
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    tranDateFromValidation() {
      if (this.forms.tranDateFrom !== '' && this.forms.tranDateFrom !== null && this.forms.tranDateFrom !== undefined) {
        return 'entry|valTranDateFrom:' + this.forms.tranDateTo
      } else {
        return 'required'
      }
    },
    tranDateToValidation() {
      if (this.forms.tranDateTo !== '' && this.forms.tranDateTo !== null && this.forms.tranDateTo !== undefined) {
        return 'entry|valTranDateTo:' + this.forms.tranDateFrom
      } else {
        return 'required'
      }
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    doInit() {},
    getBusClsHelpList() {
      this.busClsList = true
    },
    doClose() {
      this.busClsList = false
    },
    async doAssign(Obj) {
      this.forms.busCls = []
      this.forms.busCls = Obj.finalSelectedItems.toString()
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doExport() {
      const apiUrl = this.$store.state.underwriting.specialFuncUWSettings.menu.exportNCDDetails
      if (apiUrl) {
        try {
          this.loading = true
          // this.submitLabel = 'Text File'
          // const cTranDateFrom = formatDisplayDateTime2(removeTime(this.forms.tranDateFrom))
          // const cTranDateTo = formatDisplayDateTime2(removeTime(this.forms.tranDateTo))
          const expand = {
            tranDateFrom: this.forms.tranDateFrom,
            tranDateTo: this.forms.tranDateTo,
            dRi: this.forms.dRi,
            busCls: this.forms.busCls,
            format: this.forms.format
          }
          // const result = await this.$http.post(expandURI(apiUrl, expand))
          await this.$http.post(expandURI(apiUrl, expand))

          // if (result.data) {
          //   var headers = result.headers
          //   var blob = new Blob([result.data], { type: headers['content-type'] })
          //   var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
          //   downloadPrompt(blob, filename)
          // }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !isAfter(removeTime(value), removeTime(tranFromDate))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !isAfter(removeTime(tranToDate), removeTime(value))
        }
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin],
  components: {
    MultiBusClsHelpList
  }
}
</script>

<style>
</style>
